import { AssetType } from './reusableTypes';

export const isBpfsAsset = (assetType: AssetType) =>
  [
    AssetType.ETF,
    AssetType.ETC,
    AssetType.STOCK,
    AssetType.EQUITY_STOCK,
    AssetType.EQUITY_COMPLEX_ETC,
    AssetType.EQUITY_COMPLEX_ETF,
    AssetType.EQUITY_ETC,
    AssetType.EQUITY_ETF,
  ].includes(assetType);
